import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";

export const InfoBlockStyle = {
  self: css`
    h4 {
      margin-top: 25px;
      text-align: center;
      margin-bottom: 50px;
      font-size: 26px;
      font-weight: 500;
      text-transform: uppercase;
    }
  `,
  infoList: css`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 180px;
    ${media.xxl} {
      column-gap: 80px;
    }
    ${media.xxl} {
      padding: 0 60px;
    }
    ${media.md} {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
    ${media.sm} {
      grid-template-columns: 1fr;
    }
  `,
  infoItem: ({ colors, fontSize }: Theme) => css`
    line-height: 30px;
    text-align-last: justify;
    &:nth-of-type(1),
    &:nth-of-type(2),
    &:nth-of-type(5),
    &:nth-of-type(6) {
      max-width: 186px;
      ${media.xxl} {
        min-width: 206px;
      }
    }

    a {
      text-decoration: none;
      color: ${colors.white};
      font-size: ${fontSize[20]};

      min-width: 186px;
      ${media.xxl} {
        min-width: 206px;
      }
      text-align-last: justify;
    }
    ${media.md} {
      text-align: center;
    }
    &:nth-of-type(3),
    &:nth-of-type(4),
    &:nth-of-type(7),
    &:last-of-type {
      display: flex;
      justify-content: flex-end;
    }
  `,
};
